import React from 'react'
import ReactDOM from 'react-dom'
import { Button } from './Button'

interface SetupRequiredModalProps {
  show: boolean
  onConfirm: () => void
}

export const SetupRequiredModal: React.FC<SetupRequiredModalProps> = ({
  show,
  onConfirm,
}) => {
  if (!show) return null

  return ReactDOM.createPortal(
    <div className="modal-overlay show">
      <div className="modal modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">Complete Setup Required</h3>
        </div>
        <div className="modal-body">
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--color-warning)"
              strokeWidth="2"
              style={{ marginBottom: '16px' }}
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            <p style={{ color: 'var(--color-text-secondary)', marginBottom: '24px', lineHeight: '1.5' }}>
              Please complete the initial setup to analyze your company before using this feature.
            </p>
            <Button variant="primary" onClick={onConfirm} style={{ minWidth: '120px' }}>
              Go to Setup
            </Button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}
